import { FelaCSSWithCustomSelectors } from '@bridebook/ui';

interface IStylesArgs {
  withAnimation: boolean;
}

interface IStyles {
  root: FelaCSSWithCustomSelectors;
}

const styles = ({ withAnimation }: IStylesArgs): IStyles => ({
  root: {
    '& .ReactCollapse--collapse': {
      transition: withAnimation ? 'height 450ms cubic-bezier(0.4, 0, 0.2, 1)' : 'none',
    },
  },
});

export default styles;
